import { en } from "./en.js";

export type Catalog = Record<string, string>;

/** Pilot launch locales (i18n spec §4: en, es, pt-PT, ca, gl, de; Basque post-launch). */
export const LAUNCH_LOCALES = ["en", "pt-PT", "es", "ca", "gl", "de"] as const;
export type Locale = (typeof LAUNCH_LOCALES)[number];

/** A value of this literal means "intentionally untranslated — render the en string". */
export const FALLBACK_MARKER = "@en";

/** Translate `key` with `{param}` interpolation; missing keys (and @en markers) fall back to en. */
export function t(catalog: Catalog, key: string, params?: Record<string, string | number>): string {
  const raw = catalog[key];
  let s = raw === undefined || raw === FALLBACK_MARKER ? (en[key] ?? key) : raw;
  if (params) for (const [k, v] of Object.entries(params)) s = s.replaceAll(`{${k}}`, String(v));
  return s;
}

/** Override wins; else first Accept-Language whose base matches a launch locale; else en. */
export function detectLocale(accepted: readonly string[], override?: string): Locale {
  if (override && (LAUNCH_LOCALES as readonly string[]).includes(override)) return override as Locale;
  for (const a of accepted) {
    const base = a.toLowerCase().split("-")[0];
    const hit = LAUNCH_LOCALES.find((l) => l.toLowerCase().split("-")[0] === base);
    if (hit) return hit;
  }
  return "en";
}

const catalogs: Record<Locale, () => Promise<Catalog>> = {
  en: () => Promise.resolve(en),
  "pt-PT": () => import("./pt-PT.js").then((m) => m.ptPT),
  es: () => import("./es.js").then((m) => m.es),
  ca: () => import("./ca.js").then((m) => m.ca),
  gl: () => import("./gl.js").then((m) => m.gl),
  de: () => import("./de.js").then((m) => m.de),
};

export function loadCatalog(locale: Locale): Promise<Catalog> {
  return catalogs[locale]();
}
